<script setup lang="ts">
import RowItem, { RowItemProps } from '@/molecules/RowItem.vue';
import RadioRowItem from '@/molecules/RadioRowItem.vue';
import { computed } from 'vue';
import CheckboxRowItem from '@/molecules/CheckboxRowItem.vue';

export type ClickableRowItemProps = RowItemProps & { onClick?: () => Promise<any> };

export type RowItemContainerProps = {
  rowItems: ClickableRowItemProps[];
  rowItemType: 'RowItem' | 'RadioRowItem' | 'CheckboxRowItem';
  checkboxType?: 'default' | 'toggle';
  allowDeselect?: boolean;
};

const props = withDefaults(defineProps<RowItemContainerProps>(), {
  checkboxType: 'toggle',
});

const value = defineModel<string[] | boolean | undefined>();

const Component = computed(() => {
  return props.rowItemType === 'RowItem'
    ? RowItem
    : props.rowItemType === 'CheckboxRowItem'
      ? CheckboxRowItem
      : RadioRowItem;
});
</script>

<template>
  <div class="mt-2 w-full border border-secondary outline-grey-50 rounded-xl cursor-pointer">
    <component
      :type="rowItemType === 'CheckboxRowItem' ? checkboxType : undefined"
      :is="Component"
      v-for="(rowItem, index) in rowItems"
      :key="rowItem.id"
      v-model="value"
      :value="rowItem.value ?? rowItem.id"
      :bordered="index !== rowItems.length - 1"
      :allow-deselect="allowDeselect"
      v-bind="rowItem"
      :button="{
        ...rowItem.button,
        onClick: rowItem.onClick,
      }"
    >
      <slot />
    </component>
  </div>
</template>
